import ServiceBase from "base/baseService"

export default class ModeloDocFiscalService extends ServiceBase {

    title = "Modelo de documento fiscal"
    pluralTitle = "Modelo de documento fiscals"
    url = '/cadastro/fiscal/modelodoc_fiscal'
    frontUrl = '/cadastro/fiscal/modelodoc_fiscal'
    frontUrlList = '/cadastro/fiscal/modelodoc_fiscallist'
    primaryKey = 'codigo_modf'
    ignoredsSchemaConvertions = []

    prepareToFront(data = {}) {

        data.codigo_modf = data?.codigo_modf || ''
        data.descricao_modf = data?.descricao_modf || ''

        return data
    }

    prepareToSave({ data }) {

        // delete data.meta

        return data

    }

}
